import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faBell, faUserTie } from '@fortawesome/free-solid-svg-icons'
import Dropdown from 'react-bootstrap/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationAction, sidebarAction } from '../redux/SidebarSlice';
import ApiConnection from '../utils/ApiConnection';
import { NavLink } from 'react-router-dom';

const AppHeader = () => {
  const [Notification, setNotification] = useState([]);

  const sidebarShow = useSelector((state) => state.SidebarSlice.isSidebarshow)
  const datareducer = useSelector((state) => state.SidebarSlice)

  var user = JSON.parse(localStorage.getItem("user"))

const dispatch = useDispatch()

console.log(user)

function LogoutHandle(){
  localStorage.clear()
  window.location.reload()
}

useEffect(()=>{

  GetNotification()


},[])

const GetNotification = async ()=>{

  try {
      const  response = await ApiConnection.get('user-notification')
      if(response?.status == 200){
          setNotification(response?.data?.data)
          dispatch(NotificationAction(response?.data?.data))
      } else{
        
      }  
  } catch(err){
      
  }
}



  return (
    <div className='header header-sticky p-0'>
        <div className='headerToggle border-bottom px-4 py-3 d-flex align-items-center'>
            <button className='toggleBttn mr-2' onClick={()=> dispatch(sidebarAction(true)) }>
            <FontAwesomeIcon icon={faBars} />
            </button>
            {user?.first_name}   {user?.last_name} <br/>
        
            <div className='header-drop ms-auto'>
            <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic">
      <FontAwesomeIcon icon={faUserTie} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#/profile">Profile</Dropdown.Item>
        <Dropdown.Item href="#/change-password">Change Password</Dropdown.Item>
        <button onClick={LogoutHandle}>Logout</button>
      </Dropdown.Menu>
    </Dropdown>
            </div>
            <div className='notibttn'>
            <NavLink to="/notification"  className={({ isActive }) => (isActive ? "active" : undefined)}> 
            <span>
            <FontAwesomeIcon icon={faBell} />
            </span>
          <label>{datareducer?.Notification?.length}</label>
            </NavLink>
      </div>
        </div>
    </div>
  )
}

export default AppHeader